import React, { useState, useEffect } from "react";
import {useParams} from "react-router-dom";
import {
  Typography,
  Button,
  FormHelperText,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import ChipInput from "material-ui-chip-input";
import { toast } from "react-toastify";

import {
  GET_CUSTOMER_REPORTING,
  GET_CUSTOMER_REPORTING_SUCCESS,
  GET_CUSTOMER_REPORTING_FAILURE,
  UPDATE_CUSTOMER_REPORTING,
  UPDATE_CUSTOMER_REPORTING_SUCCESS,
  UPDATE_CUSTOMER_REPORTING_FAILURE
} from "@utils/actionTypes";
import { useFormik } from "formik";
import Loader from "@components/loader";
import { useStore } from "@store/store";
import API from "@services/axios";
import { ReportingStyle } from "./style";
import IOSSwitch from '@components/iOSSwitch';
import uncheckedIcon from "@assets/images/uncheck-icon.svg";
import checkedIconOrange from "@assets/images/cheked-icon-orange.svg";
import validationSchema from "@utils/validationSchemas";

const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function Reporting() {
  const classes = ReportingStyle();
  const [state, dispatch] = useStore();
  const {id} = useParams();
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const [isSwitch, setIsSwitch] = useState(false);
  const [isOldEnabled, setIsOldEnabled] = useState(false);
  const [data, setData] = useState({
    email: [],
    frequency: {
      isDaily: false,
      isWeekly: false,
      isBimonthly: false,
      isMonthly: false
    },
    isExisting: false,
    isEnabled: false
  });
  const [backupData, setBackupData] = useState({});

  const getReporting = () => {
    dispatch({type: GET_CUSTOMER_REPORTING});
    API.get(`customers/${id}/onTimePerformance`)
    .then((response) => {
      dispatch({
        type: GET_CUSTOMER_REPORTING_SUCCESS,
        payload: response.data.data,
      });

      const data = {
        email: response.data.data?.recipients ? response.data.data?.recipients.split(",") : [],
        frequency: {
          isDaily: response.data.data?.isDaily,
          isWeekly: response.data.data?.isWeekly,
          isBimonthly: response.data.data?.isBimonthly,
          isMonthly: response.data.data?.isMonthly
        },
        isExisting: true,
        isEnabled: response?.data?.data?.isEnabled
      };
      setData(data);
      setIsSwitch(data.isEnabled);
      setIsOldEnabled(response?.data?.data?.isEnabled);
      setBackupData(JSON.parse(JSON.stringify(data)));
    })
    .catch((error) => {
      dispatch({type: GET_CUSTOMER_REPORTING_FAILURE, payload: error});
      setIsSwitch(false);
    });
  };

  useEffect(() => {
    getReporting();
  }, []);

  const handleSwitchChange = (e) => {
    setIsSwitch(e.target.checked);
    if (e.target.checked) { // ON
      // Reset data if Not existing Reporting's record in Customer
      formik.resetForm({ values:  JSON.parse(JSON.stringify(data))})
      setError(false);
      setErrorMsg("");
      if (!data.isExisting) {
        formik.setFieldValue('email', []);
      }
    } else { // OFF
      if (isOldEnabled) {
        const data = {
          recipients: backupData.email.toString(),
          isDaily: backupData.frequency.isDaily,
          isWeekly: backupData.frequency.isWeekly,
          isBimonthly: backupData.frequency.isBimonthly,
          isMonthly: backupData.frequency.isMonthly,
          isEnabled: false,
        }

        dispatch({type: UPDATE_CUSTOMER_REPORTING});
        API.post(`customers/${id}/onTimePerformance`, data)
        .then((response) => {
          dispatch({
            type: UPDATE_CUSTOMER_REPORTING_SUCCESS,
            payload: response.data.data,
          });
          toast.success("OTP report disabled successfully");
          getReporting();
        })
        .catch((err) => {
          dispatch({type: UPDATE_CUSTOMER_REPORTING_FAILURE, payload: err});
        });
      }
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: data,
    validationSchema: validationSchema.editReportingValidationSchema,
    onSubmit: (value) => {
      const data = {
        recipients: value.email.toString(),
        isDaily: value.frequency.isDaily,
        isWeekly: value.frequency.isWeekly,
        isBimonthly: value.frequency.isBimonthly,
        isMonthly: value.frequency.isMonthly,
        isEnabled: true,
      }

      dispatch({type: UPDATE_CUSTOMER_REPORTING});
      API.post(`customers/${id}/onTimePerformance`, data)
      .then((response) => {
        dispatch({
          type: UPDATE_CUSTOMER_REPORTING_SUCCESS,
          payload: response.data.data,
        });
        toast.success("OTP report enabled successfully");
        getReporting();
      })
      .catch((err) => {
        dispatch({type: UPDATE_CUSTOMER_REPORTING_FAILURE, payload: err});
      });
    }
  })

  const handleChange = (e) => {
    const newArray = formik.values.email;
    let isError = false;

    if (e) {
      if (!newArray.includes(e.trim())) {
        newArray.push(e.trim());
      }
    }

    if (newArray?.length === 0) {
      setError(true);
      setErrorMsg("Recipient email is required.");
    } else {
      isError = newArray.some(email => !re.test(email));

      if (isError) {
        setError(true);
        setErrorMsg("Wrong email format.");
      } else {
        setErrorMsg("");
        setError(false);
        formik.setFieldTouched('email', true);
      }
    }
  };

  const handleDeleteChip = (e) => {
    const index = formik.values.email.indexOf(e);
    const newArray = formik.values.email;
    newArray.splice(index, 1);
    formik.setFieldValue('email', newArray);
    if (newArray.length > 0) {
      let isError = newArray.some(email => !re.test(email));

      if (isError) {
        setError(true);
        setErrorMsg("Wrong email format.");
      } else {
        setErrorMsg("");
        setError(false);
        formik.setFieldTouched('email', true);
      }
    } else {
      setError(true);
      setErrorMsg("Recipient email is required.");
    }
  };

  const handleChangeFrequency = (e, title) => {
    switch (title) {
      case "Daily":
        formik.setFieldValue('frequency.isDaily', e.target.checked);
        break;
      case "Weekly":
        formik.setFieldValue('frequency.isWeekly', e.target.checked);
        break;
      case "BiMonthly":
        formik.setFieldValue('frequency.isBimonthly', e.target.checked);
        break;
      case "Monthly":
        formik.setFieldValue('frequency.isMonthly', e.target.checked);
        break;
    }
  }

  return (
    <div className={classes.ReportingWrapper}>
      <Loader
        loading={
          state?.customer?.loadingCustomerReporting ||
          state?.customer?.updatingCustomerReporting
        }
      />
      <div className={classes.customBox}>
        <form
          noValidate
          autoComplete="off"
          className={classes.customForm}
          onSubmit={formik.handleSubmit}
        >
          <div className="header">
            <Typography>
              <span>On Time Performance Report</span>
              <div className="switch">
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={isSwitch}
                      onChange={handleSwitchChange}
                    />
                  }
                />
              </div>
            </Typography>

          </div>
          {isSwitch && (
            <div className="content">
              <div className="emails">
                <div className="title">Report Recipient Email(s)</div>
                <ChipInput
                  className="chip-input"
                  id="email"
                  name="email"
                  value={
                    formik.values.email &&
                    typeof formik.values.email !== "string"
                      ? formik.values.email
                      : []
                  }
                  onChange={formik.handleChange}
                  onAdd={(e) => handleChange(e)}
                  onBlur={(e) => handleChange(e.target.value)}
                  onDelete={(e) => handleDeleteChip(e)}
                  placeholder="user@example.com"
                  error={
                    error
                      ? errorMsg
                      : formik.touched.email &&
                      Boolean(formik.errors.email)
                  }
                />
                <FormHelperText className="error-text">
                  {error
                    ? errorMsg
                    : formik.touched.email &&
                    formik.errors.email}
                </FormHelperText>
                <div className="tip">Enter one or more emails.</div>
              </div>
              <div className="frequency">
                <div className="title">Report Frequency</div>
                <div className="box-container">
                  <div className="box-holder">
                    <div className="box">
                      <FormControlLabel
                        className={formik.touched.frequency && formik.errors.frequency ? "error-holder" : ""}
                        control={
                          <Checkbox
                            icon={<img src={uncheckedIcon} alt="UnCheckBox"/>}
                            checkedIcon={
                              <img src={checkedIconOrange} alt="CheckBox"/>
                            }
                            onChange={(e) => handleChangeFrequency(e, "Daily")}
                            checked={formik.values.frequency.isDaily}
                            name="checkedDaily"
                          />
                        }
                        label="Daily"/>
                    </div>
                    <div className="box">
                      <FormControlLabel
                        className={formik.touched.frequency && formik.errors.frequency ? "error-holder" : ""}
                        control={
                          <Checkbox
                            icon={<img src={uncheckedIcon} alt="UnCheckBox"/>}
                            checkedIcon={
                              <img src={checkedIconOrange} alt="CheckBox"/>
                            }
                            onChange={(e) => handleChangeFrequency(e, "Weekly")}
                            checked={formik.values.frequency.isWeekly}
                            name="checkedWeekly"
                          />
                        }
                        label="Weekly"/>
                    </div>
                    <div className="box">
                      <FormControlLabel
                        className={formik.touched.frequency && formik.errors.frequency ? "error-holder" : ""}
                        control={
                          <Checkbox
                            icon={<img src={uncheckedIcon} alt="UnCheckBox"/>}
                            checkedIcon={
                              <img src={checkedIconOrange} alt="CheckBox"/>
                            }
                            onChange={(e) => handleChangeFrequency(e, "BiMonthly")}
                            checked={formik.values.frequency.isBimonthly}
                            name="checkedBiMonthly"
                          />
                        }
                        label="Bi-monthly"/>
                    </div>
                    <div className="box">
                      <FormControlLabel
                        className={formik.touched.frequency && formik.errors.frequency ? "error-holder" : ""}
                        control={
                          <Checkbox
                            icon={<img src={uncheckedIcon} alt="UnCheckBox"/>}
                            checkedIcon={
                              <img src={checkedIconOrange} alt="CheckBox"/>
                            }
                            onChange={(e) => handleChangeFrequency(e, "Monthly")}
                            checked={formik.values.frequency.isMonthly}
                            name="checkedMonthly"
                          />
                        }
                        label="Monthly"/>
                    </div>
                  </div>
                  {formik.touched.frequency && formik.errors.frequency && (
                    <FormHelperText className="error-text">{formik.errors.frequency}</FormHelperText>
                  )}
                </div>
              </div>
              <Button
                className="orange-btn primary-btn"
                color="inherit"
                disableElevation
                type="submit"
              >
                SAVE
              </Button>
            </div>)
          }
        </form>
      </div>
    </div>
  );
}

export default Reporting;
